<script setup>
import AdminBlock from '@/components/movements/components/AdminBlock.vue';
import axios from 'axios';
import Modal from 'bootstrap/js/dist/modal';
import { successAlert, errorAlert } from "@/utils";
import { ref, computed, onMounted } from 'vue';

const props = defineProps({
    identifier: {
        type: String,
        default: '',
        required: false,
    },
    movement: {
        type: Object,
        default: () => {
        },
        required: false,
    },
    job: {
        type: Object,
        default: () => {
        },
        required: false,
    },
    modalFor: {
        type: String,
        default: '',
        required: false,
    }
});

const emit = defineEmits(['movement-aborted', 'evidence-updated']);

const reason = ref('');

const modal = ref({});

const getModalType = () => {
    return props.modalFor !== '' ? props.modalFor + '_' : '';
}

const abortMovement = () => {

    const data = {
        aborted_admin_reason: reason.value,
    }

    const url = route('api.movements.movements.abort-job', {movement: props.movement.id});

    axios.post(url, data)
        .then(response => {
            window.jQuery('.modal-header .btn-close').click();
            successAlert('Movement aborted successfully', 'Success')
                .then(() => {
                    window.location.href = route('movements.jobs.show', {job: props.movement.job.id});
                });
        })
        .catch(error => {
            errorAlert(error, 'Error creating evidence');
        });
}

const compModalIdentifier = computed(() => {
    return props.identifier + '_abort_modal';
});

onMounted(() => {
    modal.value = new Modal(document.getElementById(compModalIdentifier.value));
});

</script>

<template>
    <div class="modal" :id="compModalIdentifier" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 900px;">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-center">
                        Aborting Job at Movement {{ movement.position }}
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body bg-light">
                    <fieldset>
                        <div class="row">
                            <div class="col-12">
                                <AdminBlock title="Job Details" class="mb-3">
                                    <p class="mb-2">
                                        <strong>
                                            Job:
                                        </strong>
                                        {{ movement.job.reference }}
                                    </p>
                                    <p class="mb-2">
                                        <strong>
                                            Journey:
                                        </strong>
                                        <template v-if="movement.job?.collection_company && movement.job.collection_company.length > 0">
                                            {{ movement.job.collection_company }},
                                        </template>
                                        {{ movement.job.collection_location }}
                                        to
                                        <template v-if="movement.job?.delivery_company && movement.job.delivery_company.length > 0">
                                            {{ movement.job.delivery_company }},
                                        </template>
                                        {{ movement.job.delivery_location }}
                                    </p>
                                    <p class="mb-2">
                                        <strong>
                                            Vehicle:
                                        </strong>
                                        {{ movement.job.vehicle.reg + ' ' + movement.job.vehicle.description }} <span style="white-space:nowrap">({{ movement.job.vehicle.vehicle_type.type }})</span>
                                    </p>
                                    <p class="mb-2">
                                        <strong>
                                            Customer:
                                        </strong>
                                        {{ movement.job.customer.name }}
                                    </p>
                                    <p class="mb-2">
                                        <strong>
                                            Contract:
                                        </strong>
                                        {{ movement.job.contract.name }}
                                    </p>
                                    <p class="mb-0">
                                        <strong>
                                            Purchase Order (Client Ref)
                                        </strong>
                                        {{ movement.job.client_ref }}
                                    </p>
                                </AdminBlock>

                                <AdminBlock title="Reason for Aborting" remove-margin>
                                    <textarea class="form-control" rows="8" v-model="reason"></textarea>
                                </AdminBlock>
                            </div>
                        </div>
                    </fieldset>
                </div>

                <div class="modal-footer">
                    <button type="button"
                            :id="'create_' + getModalType() + 'contact_close_button'"
                            class="btn btn-secondary"
                            data-bs-dismiss="modal">Close
                    </button>

                    <button type="button" class="btn btn-primary" @click="abortMovement()">
                        Abort
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
